// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c857f15","455":"ee6b7c02"}[chunkId] + ".chunk.js";
};